import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ErrorTextService } from './error-text.service';

export type ToastTypes = 'error' | 'success' | 'info' | 'warning';
export type ToastDescription = {
  show: boolean;
  /**May include new lines.  Will be in a whitespace:pre element */
  message?: string;
  details?: string;
  type?: ToastTypes;
};

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastSubject = new Subject<ToastDescription>();
  public toastState = this.toastSubject.asObservable();

  constructor(private errorTextService: ErrorTextService) {}

  /**
   * @see {ErrorTextService.getFriendlyMessage} and expand as needed.
   * @param message Base Error Message (first line of the toast).  Typically things like "Unable to Delete Aircraft"
   * @param error the error to parse.  Passes the error to ErrorTextService.getFriendlyMessage(error).
   */
  showFullError(message: string, error: Error) {
    let details = this.errorTextService.getFriendlyMessage(error);
    this.toastSubject.next({
      show: true,
      message,
      details,
      type: 'error'
    });
  }

  show(message: string, type?: ToastTypes) {
    this.toastSubject.next({
      show: true,
      message,
      type
    });
  }

  dismiss() {
    this.toastSubject.next({
      show: false
    });
  }
}
